<div container-principal>
    <header>
        <object data="assets\agview-connect\conclude.svg" type="image/svg+xml">
            {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SUCESSO.CONFIRM" | transloco }}
        </object>
        <span class="font-13">
            <b>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SUCESSO.TITLE" | transloco }}</b>
        </span>
    </header>
    <article class="w-100 d-flex justify-content-center flex-column">
        <p class="w-100" [innerHTML]="'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SUCESSO.MESSAGE' | transloco"></p>
    </article>
    <footer class="d-flex w-100">
        <button (click)="confirmar()">
            <object data="assets\agview-connect\check.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_SUCESSO.CONFIRM" | transloco }}</span>
        </button>
    </footer>
</div>